import { initStatementIconNumeration } from './statement-icon-numeration'

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.JumbotronClaim--carousel .swiper')
    .forEach(async (container) => {
      const { tns } = await import('tiny-slider/src/tiny-slider')
      const numSlides = container.querySelectorAll(
        '.JumbotronClaim__slide',
      ).length

      tns({
        container,
        preventScrollOnTouch: 'auto',
        items: 1,
        // `loop` clones every slide, which duplicates their headings in the DOM.
        // `rewind` wraps without cloning.
        rewind: true,
        mouseDrag: true,
        swipeAngle: 30,
        slideBy: 'page',
        controls: false,
        autoplay: numSlides > 1,
        autoplayTimeout: 7000,
        autoplayButtonOutput: false,
        nav: numSlides > 1,
        navPosition: 'bottom',
      })
    })

  document
    .querySelectorAll('.JumbotronClaim--gallery .swiper')
    .forEach(async (container) => {
      const { tns } = await import('tiny-slider/src/tiny-slider')
      const numSlides = container.querySelectorAll(
        '.JumbotronClaim__slide',
      ).length

      tns({
        container,
        preventScrollOnTouch: 'auto',
        items: 1,
        // `loop` clones every slide, which duplicates their headings in the DOM.
        // `rewind` wraps without cloning.
        rewind: true,
        mouseDrag: true,
        swipeAngle: 30,
        slideBy: 'page',
        controls: false,
        autoplay: numSlides > 1,
        autoplayTimeout: 7000,
        autoplayButtonOutput: false,
        nav: numSlides > 1,
        mode: 'gallery',
        navPosition: 'bottom',
      })
    })

  document
    .querySelectorAll('.IconShortText--slider-mode')
    .forEach((container) => {
      const swiper = container.querySelector('.swiper')
      if (!swiper) return

      const slides = Array.from(swiper.children) as HTMLElement[]
      if (slides.length === 0) return

      // Randomize icon order on each load 
      for (let i = slides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[slides[i], slides[j]] = [slides[j], slides[i]]
      }

      const track = document.createElement('div')
      track.className = 'IconShortText__track'

      slides.forEach((slide) => track.appendChild(slide))
      swiper.appendChild(track)

      const appendCloneSet = () => {
        slides.forEach((slide) => {
          const clone = slide.cloneNode(true) as HTMLElement
          clone.setAttribute('aria-hidden', 'true')
          track.appendChild(clone)
        })
      }

      const originalWidth = track.scrollWidth
      const minTrackWidth = window.innerWidth * 2
      let totalSets = 1
      appendCloneSet()
      totalSets++
      while (originalWidth * totalSets < minTrackWidth) {
        appendCloneSet()
        totalSets++
      }

      const SLIDER_SPEED_PX_PER_SEC = 50;
      const duration = Math.max(originalWidth / SLIDER_SPEED_PX_PER_SEC, 5)
      track.style.animationDuration = `${duration}s`
      track.style.setProperty('--icon-short-text-loop-offset', `-${100 / totalSets}%`)
    })
  document.querySelectorAll('.LineComparison').forEach(async (container) => {
    const { tns } = await import('tiny-slider/src/tiny-slider')
    tns({
      container: container.querySelector('.swiper')!,
      preventScrollOnTouch: 'auto',
      items: 1,
      swipeAngle: 30,
      loop: false,
      center: true,
      autoWidth: true,
      slideBy: 'page',
      controls: true,
      nav: false,
      // @ts-ignore
      viewportMax: true,
      prevButton: container.querySelector(
        '.LineComparison__prev',
      ) as HTMLElement,
      nextButton: container.querySelector(
        '.LineComparison__next',
      ) as HTMLElement,
      disable: false,
      responsive: {
        768: {
          disable: true,
          center: false,
        },
      },
    })
    container
      .querySelector('.js-details-btn')
      ?.addEventListener('click', (e) => {
        const svg = (e.currentTarget as HTMLElement).querySelector('svg use')
        svg?.setAttribute(
          'xlink:href',
          svg?.getAttribute('xlink:href') === '#plus' ? '#minus' : '#plus',
        )
        container.classList.toggle('LineComparison--collapsed')
      })
  })

  initStatementIconNumeration()

  document
    .querySelectorAll('.OfferDetail__swiper-container')
    .forEach(async (container) => {
      const { tns } = await import('tiny-slider/src/tiny-slider')
      tns({
        container: container.querySelector('.OfferDetail__swiper')!,
        preventScrollOnTouch: 'auto',
        swipeAngle: 30,
        items: 1,
        loop: true,
        autoWidth: true,
        slideBy: 'page',
        controls: true,
        autoplay: false,
        autoplayTimeout: 7000,
        autoplayButtonOutput: false,
        onInit: () => {
          container.classList.remove('OfferDetail__swiper-container--hidden')
        },
        prevButton: container.querySelector(
          '.OfferDetail__prev',
        ) as HTMLElement,
        nextButton: container.querySelector(
          '.OfferDetail__next',
        ) as HTMLElement,
        navContainer: container.querySelector(
          '.OfferDetail__nav-container',
        ) as HTMLElement,
        nav: true,
        navAsThumbnails: true,
        navPosition: 'bottom',
      })
    })
})
